module.exports = __webpack_public_path__ + "img/menu-img.f07cefa8.png";